import { DatePicker, DatePickerProps, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import { Moment } from "moment"
import { useFieldsStyles } from "./FieldsStyles"

interface CustomDatePickerProps extends DatePickerProps<Moment> {
    gutterBottom?: "md" | "sm"
    helperText?: string
    required?: boolean
    minDateMessage?: string
    dataTestId?: string
}

export const DatePickerCustom = ({
    value,
    gutterBottom = undefined,
    helperText,
    required,
    dataTestId,
    ...props
}: CustomDatePickerProps) => {
    const { classes, cx } = useFieldsStyles()

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
                format="MM/DD/YYYY"
                value={value}
                className={cx(classes.input__sm, !!gutterBottom && classes[`gutterBottom__${gutterBottom}`])}
                slotProps={{
                    textField: {
                        error: required && !value,
                        helperText: helperText ?? (required && "Required"),
                        variant: "outlined",
                        fullWidth: true,
                        inputProps: {
                            "data-testid": dataTestId,
                        },
                    },
                    toolbar: { hidden: true },
                }}
                {...props}
            />
        </LocalizationProvider>
    )
}
